// A CASE WITH NO BOARD CANNOT BE APPROVED (v1_821c).
//
// A documents first analysis that stopped before assembly leaves the case with
// no board: report null or {}, or none of the assembled sections. The dashboard
// skipped the whole case view for it (report read as null) and showed a generic
// "not generated" screen whose only action was the conversation Regenerate, and
// nothing in sign off refused an approval (Calder Ridge shape). One rule here,
// read by the no board view, the decision panel and the sign off gate.
import { analysisRunState, nextAction, buildNextActionState } from './next-action.js';

export const ANALYSIS_NOT_COMPLETE = 'Analysis not complete';

export function boardMissing(report) {
  if (!report || typeof report !== 'object' || !Object.keys(report).length) return true;
  const has = (k) => Array.isArray(report[k]) ? report[k].length > 0 : !!report[k];
  return !(has('clientName') || has('companyDetails') || has('ubos') || has('directors') || has('riskAssessment') || has('riskTier'));
}

// Is approval blocked by the analysis? Only a case with no board is; a case
// whose later run stopped keeps the board it has (and its own Reprocess row).
export function approvalBlockedByAnalysis({ report } = {}) {
  const noBoard = boardMissing(report);
  return { blocked: noBoard, noBoard, why: noBoard ? ANALYSIS_NOT_COMPLETE : null };
}

// The no board case derives as Gather, and its next action is the Reprocess
// prompt (or "Analysis in progress" while a run is going). A strip with
// nothing running and no board is a stopped analysis, whatever its lines say.
export function noBoardCaseState({ report, analysisProgress, nowMs = Date.now() } = {}) {
  if (!boardMissing(report)) return null;
  const rs = analysisRunState(analysisProgress, nowMs);
  const running = !!rs.running;
  const na = nextAction(buildNextActionState({ stage: 0, analysisRunning: running, analysisStopped: !running }));
  return { stage: 0, stageName: 'Gather', running, stopped: !running, nextAction: na, approveBlockedWhy: ANALYSIS_NOT_COMPLETE };
}
